/**
 * Zod schemas for File Upload plugin - accepted file types, size limits, and uploaded file URLs.
 */
import { z } from "zod";
/**
 * Configuration schema for the file upload step type.
 */
export const configSchema = z.object({
    acceptedTypes: z.array(z.string()).default(["*"]),
    maxFiles: z.number().min(1).max(20).default(5),
    maxSizeMB: z.number().min(1).max(100).default(10),
    instructions: z.string().optional(),
});
/**
 * Data schema for file upload step execution.
 */
export const dataSchema = z.object({
    fileUrls: z.array(z.string()),
});
export const defaultConfig = {
    acceptedTypes: ["*"],
    maxFiles: 5,
    maxSizeMB: 10,
};
//# sourceMappingURL=schema.js.map